<template>
  <div class="form-group">
    <div class="input-group">
      <textarea
        :value="value"
        :id="'input' + name"
        :required="required"
        :rows="rows"
        class="resizeable"
        @input="$emit('input', $event.target.value)"
        @blur="$emit('blur', $event.target.value)"
      />
      <label
        v-if="label"
        :for="'input' + name"
        class="control-label"
      >
        {{ label }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FieldTextarea',

  props: {
    value: {
      required: true,
      type: [String, Number]
    },
    name: {
      type: [String, Number],
      default: null
    },
    label: {
      required: false,
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 10
    }
  }
}
</script>

<style lang="scss">
  textarea.resizeable {
    resize: auto;
    border: 1px solid;
    margin-top: 5px;
  }
</style>
